import {
  PropElementResponse,
  PropElementRequest,
} from '../../../services/proposal';
import { toDatePickerDate } from 'utils/utils2';
import { ParOffer } from 'services/pricing';
export function conElementToElement(
  elements: Array<PropElementResponse>,
  ctOffer: ParOffer
): Array<PropElementRequest> {
  const list = elements?.map((element) => {
    let ctepartratespread = element?.ctepartratespread ?? 0;
    return {
      offer: {
        ofrid: element.ofrid,
        ofrtype: element.ofrtype,
        ofrlabel: element.ofrlabel,
        ofrdescription: '',
      },
      ofrid: element.ofrid,
      ofrlabel: element.ofrlabel,
      ofrtype: element.ofrtype,
      assetid: element.assetid,
      conElemAssets: element.conElemAssets,
      conElemSchedules: element.conElemSchedules,
      conElemIFRS: element.conElemIFRS,
      conElemSpreading: element.conElemSpreading,
      conElemSteps: element.conElemSteps,
      conElemAttributes: element.conElemAttributes,
      conElemServiceSteps: element.serviceStepList,
      conElemPrefinSteps: element.conElemPrefinSteps.map((el) => ({
        ...el,
        calcmethod: el.calmethod,
      })),
      ctebilligdate: element.ctebilligdate,
      cteactuarialrate: element.cteactuarialrate,
      ctecalculationbasis: element.ctecalculationbasis,
      ctecalculationtype: element.ctecalculationtype,
      ctecategory: element.ctecategory,
      ctecategorylabel: element.ctecategorylabel,
      ctedeferredinterest: element.ctedeferredinterest,
      ctedeferredinterestmethod: element.ctedeferredinterestmethod,
      ctedeferredinterestnominalrate: element.ctedeferredinterestnominalrate,
      ctedepositamount: element.ctedepositamount,
      ctedepositcoef: element.ctedepositcoef,
      ctedepositinterest: element.ctedepositinterest,
      ctedepositinterestmethod: element.ctedepositinterestmethod,
      ctedepositnominalrate: element.ctedepositnominalrate,
      ctedescription: element.ctedescription,
      ctedirection: element.ctedirection,
      cteduration: element.cteduration,
      cteendamount: element.cteendamount,
      cteenddate: toDatePickerDate(element.cteenddate),

      ctefinancedamount: element.ctefinancedamount,
      ctefirstpayment: element.ctefirstpayment, //0,
      ctefirstpaymentcoef: element.ctefirstpaymentcoef,
      ctefirstpaymentdate: element.ctefirstpaymentdate,
      ctefree1: element.ctefree1,
      ctegraceperiodduration: element.ctegraceperiodduration,
      ctegraceperiodmethod: element.ctegraceperiodmethod,
      cteid: element.cteid,
      cteidparent: element.cteidparent,
      cteinitialamount: element.cteinitialamount,
      cteinstallmentamount: element.cteinstallmentamount,
      cteinterestmethod: element.cteinterestmethod,
      cteinvestamount: element.cteinvestamount,
      ctenominalrate: element.ctenominalrate,
      cteorder: element.cteorder,
      ctepartamount: element.ctepartamount,
      ctepartdays: element.ctepartdays,
      ctepartmethod: element.ctepartmethod,
      ctepartrate: element.ctepartrate,
      servbasis: element.servbasis,
      ctepaymentterm: element.ctepaymentterm,
      cteperiodicity: element.cteperiodicity,
      cteratebasis: element.cteratebasis,
      cterateformula: element.cterateformula,
      cterateperiodicity: element.cterateperiodicity,
      cteratespread: element.cteratespread,
      cterateterm: element.cterateterm,
      cteratetype: element.cteratetype,
      cterentalamount: element.cterentalamount,
      ctervamount: element.ctervamount, //element.rvdefaultamount,
      ctervcoef: element.ctervcoef,
      ctestartamount: element.ctestartamount,
      ctestartdate: toDatePickerDate(element.ctestartdate),
      ctestatus: element.ctestatus,
      ctetype: element.ctetype,
      cteunit: element.cteunit,
      cteupfrontamount: element.cteupfrontamount,
      ctrid: element.ctrid,
      currcode: element.currcode,
      ctemileage: element.ctemileage,
      ctepriidexceed: element.ctepriidexceed,
      last_action: element.last_action,
      prefinbasis: element.prefinbasis,
      prefinmethod: element.prefinmethod,
      prefinnominalrate: element.prefinnominalrate,
      prefinperiodicity: element.prefinperiodicity,
      prefinrateformula: element.prefinrateformula,
      prefinratetype: element.prefinratetype,
      rvcalculationmode: element.rvcalculationmode,
      rvevaluationmode: element.rvevaluationmode,
      prefinrateref: element.prefinrateref,
      prefinratespread: element.prefinratespread,
      cterateref: element.cterateref,
      priid: element.priid,
      taxcode: element.taxcode,
      taxrate: element.taxrate,
      taxtype: element.taxtype,
      tpid: element.tpid,
      tpidparticipation: {
        tpid: element.tpidparticipation,
        // tpreference: element?.tpreferenceparticipation,
        tpname: element.tpnamepart,
      },
      calculatedamountbasis:
        element.serviceResponse?.calculatedamountbasis ?? '',
      marginoncalulatedcamount:
        element.serviceResponse?.marginoncalulatedamount ?? 0,
      additionalcostaftermargin:
        element.serviceResponse?.additionalcostaftermargin ?? 0,
      servfixedamount: element.servfixedamount,
      servpercentage: element.servpercentage,
      depositratetype:
        element.pricing?.depositratetype ?? ctOffer.depositratetype,
      deferredinterestratetype:
        element.pricing?.deferredinterestratetype ??
        ctOffer.deferredinterestratetype ??
        ctOffer.durationmax,
      pritype: '',
      helpers: {
        servfixedamountmin: element.pricing?.servfixedamountmin,
        servpercentagemin: element.pricing?.servpercentagemin,
        servcontextmin: element.pricing?.servcontextmin,
        durationmax: element.pricing?.durationmax ?? ctOffer.durationmax,
        durationcontextmax:
          element.pricing?.durationcontextmax ??
          ctOffer.durationcontextmax ??
          ctOffer.durationmax,
        durationcontextmin:
          element.pricing?.durationcontextmin ??
          ctOffer.durationcontextmin ??
          ctOffer.durationmin,
        durationmin: element.pricing?.durationmin ?? ctOffer.durationmin,

        frmin: element.pricing?.firstrentalmin ?? ctOffer.firstrentalmin,
        frmax: element.pricing?.firstrentalmax ?? ctOffer.firstrentalmax,
        frcontextmax:
          element.pricing?.frcontextmax ??
          ctOffer.frcontextmax ??
          ctOffer.firstrentalmax,
        frcontextmin:
          element.pricing?.frcontextmin ??
          ctOffer.frcontextmin ??
          ctOffer.firstrentalmin,

        upmax: element.pricing?.upfrontmax ? element.pricing.upfrontmax : 0, //50,
        upmin: element.pricing?.upfrontmin ? element.pricing.upfrontmin : 0,
        rvmax: element.pricing?.rvmax ?? ctOffer.rvmax,
        rvmin: element.pricing?.rvmin ?? ctOffer.rvmin,

        gpmax: element.pricing?.gpmax ?? ctOffer.gpmax ?? 15,
        gpmin: element.pricing?.gpmin ?? ctOffer.gpmin ?? 0,
        rvcontextmax:
          element.pricing?.rvcontextmax ??
          ctOffer.rvcontextmax ??
          ctOffer.rvmax,
        rvcontextmin:
          element.pricing?.rvcontextmin ??
          ctOffer.rvcontextmin ??
          ctOffer.rvmin,
        marginratemin: element.pricing?.marginratemin,
        margincontextmin: element.pricing?.margincontextmin,
        marginratemax: element.pricing?.marginratemax,
        margincontextmax: element.pricing?.margincontextmax,

        gpdurationmax: element.pricing?.gpduration ?? ctOffer.gpduration,
        ratemax:
          element.pricing?.ratevaluedefault + element.pricing?.ratespreadmax ??
          ctOffer.ratevaluedefault + ctOffer.ratespreadmax,

        ratemin:
          element.pricing?.ratevaluedefault + element.pricing?.ratespreadmin ??
          ctOffer.ratevaluedefault + ctOffer.ratespreadmin,
        ratecontextmax:
          element.pricing?.ratevaluedefault + element.pricing?.ratecontextmax ??
          ctOffer.ratevaluedefault + ctOffer.ratecontextmax,

        ratecontextmin:
          element.pricing?.ratevaluedefault + element.pricing?.ratecontextmin ??
          ctOffer.ratevaluedefault + ctOffer.ratecontextmin,
      },
      spvassetdiscount: element.spvassetdiscount,
      spvriskrate: element.spvriskrate,
      spvadditionalfees: element.spvadditionalfees,
      spvloancoef: element.spvloancoef,
      spvdiscountsale: element.spvdiscountsale,
      spvinflation: element.spvinflation,
      spvassetdiscountamount: element.spvassetdiscountamount,
      spvloanamount: element.spvloanamount,
      spvriskamount: element.spvriskamount,
      spvfeesamount: element.spvfeesamount,

      serviceResponse: element.serviceResponse ?? [],
      commissionResponse: element.commissionResponse ?? [],
      serviceStepList: element.serviceStepList ?? [],
      pricing: element.pricing ?? [],
      pricingStepList: element.pricingStepList ?? [],
      rvauthid: element.rvauthid,
      rvtaskid: element.rvtaskid,
      rateauthid: element.rateauthid,
      ratetaskid: element.ratetaskid,
      frauthid: element.frauthid,
      frtaskid: element.frtaskid,
      durationauthid: element.durationauthid,
      durationtaskid: element.durationtaskid,
      servtaskid: element.servtaskid,
      servauthid: element.servauthid,
      margintaskid: element.margintaskid,
      marginauthid: element.marginauthid,
      ctefeesamount: element.ctefeesamount,
      ctecommissionamount: element.ctecommissionamount,
      cteprofitabilityrate: element.cteprofitabilityrate,
      cteaprrate: element.cteaprrate,
      cteflatrate: element.cteflatrate,
      ctecoefrate: element.ctecoefrate,
      ctefundingrate: element.ctefundingrate,
      ctefundingperiodicity: element.ctefundingperiodicity,
      ctefundinginstallment: element.ctefundinginstallment,
      ctefundingcost: element.ctefundingcost,
      ctemarginamount: element.ctemarginamount,
      ctemarginrate: element.ctemarginrate,
      ctevatdeferralamount: element.ctevatdeferralamount,
      ctevatdeferralduration: element.ctevatdeferralduration,
      ctevatdeferralmethod: element.ctevatdeferralmethod,
      ctevatdeferraldaysbasis: element.ctevatdeferraldaysbasis,
      cteextracosttofinance: element.cteextracosttofinance,
      cteextracostcomment: element.cteextracostcomment,
      totalInterest: 0,
      totalRental: 0,
      totalAmortization: 0,
      totaldiscountedInterest: 0,
      totalVatDeffered: 0,
      totaldiscountedOutstanding: 0,
      totaldiscountedAgiosdeb: 0,
      totalAgiosdeb: 0,
      marginImpactCredit: 0,
      marginImpactDebit: 0,
      dgo: 0,
      profitabilityAmount: 0,
      payid: element.payid,
      payidreimbursment: element.payidreimbursment,
      payrefrence: element.payrefrence,
      payreimbreference: element.payreimbreference,
      ctestatuslabel: element?.ctestatuslabel,
      ceilingrate: element.ceilingrate,
      ceilingdefaultrate: element.ceilingdefaultrate,
      floorrate: element.floorrate,
      floordefaultrate: element.floordefaultrate,
      calid: element.calid,
      ctepartratetype: element.ctepartratetype,
      ctepartrateformula: element.ctepartrateformula,
      ctepartinvoicingmode: element.ctepartinvoicingmode,
      ctepartratedefault: element.ctepartrate - ctepartratespread,
      ctepartratespread: element.ctepartratespread,
      servusecoverage:element.servusecoverage,
      servusedeductionamount:element.servusedeductionamount,
      servusedeductionpercenrage:element.servusedeductionpercenrage,
      servusefrequency:element.servusefrequency,
      servusemaxamount:element.servusemaxamount,
      servuseminamount:element.servuseminamount,
      servuseqty:element.servuseqty,
      servuseunit:element.servuseunit,
      servdescription:element.servdescription,
    };
  });
  return list;
}
